<form class="popupForm" style="min-height: 400px;">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: 400px;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      {{'Profile info' | GetLabelPipe}}
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke"
                        style="">
      <div class="event-view-content event-view-content-first-row" style="justify-content: flex-start;">
        <div class="flex-column-center" style="width: 100%;">
          <div class="flex-row-center flex-justify-space-around" style="width: 100%;">
            <div matRipple class="profile-right-button flex-column-center column-button" (click)="rotateImage(-90)">
              <mat-icon *ngIf="state == 'default'">rotate_right</mat-icon>
              <mat-icon *ngIf="state == 'error'">warning</mat-icon>
              <mat-icon *ngIf="state == 'loading'">hourglass_empty</mat-icon>
            </div>
            <div class="event-user-icon event-user-icon-first-row" (click)="showUser()">
              <img src="{{profile.picture_src_preview}}"
                   alt="{{profile.shipping_name}}" title="{{profile.shipping_name}}"
                   style="{{ profile.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
              />
            </div>
            <div matRipple class="profile-right-button flex-column-center column-button" (click)="rotateImage(90)">
              <mat-icon *ngIf="state == 'default'">rotate_left</mat-icon>
              <mat-icon *ngIf="state == 'error'">warning</mat-icon>
              <mat-icon *ngIf="state == 'loading'">hourglass_empty</mat-icon>
            </div>
          </div>
          <div class="user-name flex-row-center flex-justify-center">
            <div matRipple *ngIf="false" (click)="openProfileEditPopup()"
                 class="profile-right-button flex-column-center column-button" style="margin-right: 12px;">
              <mat-icon>edit</mat-icon>
            </div>
            <div>{{profile.shipping_name}}</div>
          </div>
        </div>
<!--        <div class="flex-row-start flex-justify-center">-->
        <div class="flex-justify-center"
             [class.flex-row-start]="!application.isHandset"
             [class.flex-column-center]="application.isHandset">
          <div *ngIf="!isOwner" class="event-description flex-column-center flex-justify-space-around" style="margin-bottom: 30px;">
            <div style="margin: 14px 0px; width: 100%;" class="flex-row-center flex-justify-start">
              <mat-slide-toggle [checked]="isPrepaidBookings" (change)="prepaidToggle($event)">
                {{'Prepaid bookings' | GetLabelPipe}}
              </mat-slide-toggle>
            </div>
            <div style="margin: 14px 0px; width: 100%;" class="flex-row-center flex-justify-start">
              <mat-slide-toggle [checked]="forbidGuestBookings" (change)="guestBookingToggle($event)">
                {{'Forbid guest booking' | GetLabelPipe}}
              </mat-slide-toggle>
            </div>
            <div style="margin: 14px 0px; width: 100%;" *ngIf="application.account.payload_parsed['discount_period_duration']">
              <div style="margin-bottom: 10px;">
                {{'Discount prices' | GetLabelPipe}}
                <ng-container *ngIf="discountExpired"><b class="error-color">Expired</b></ng-container>
                <ng-container *ngIf="!discountExpired"><b class="success-color">&nbsp;ON</b></ng-container>
              </div>
              <mat-form-field appearance="outline" color="accent">
                <mat-label>Expire date</mat-label>
                <input matInput type="text" [matDatepicker]="dp1" [value]="discountExpireDate"
                       (change)="discountExpireChange($event)" (dateChange)="discountExpireChange($event)"
                       (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()">
                <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                <mat-datepicker #dp1 disabled="false"></mat-datepicker>
              </mat-form-field>
            </div>
            <div style="margin: 14px 0px; width: 100%;" class="flex-row-center flex-justify-start">
              <mat-slide-toggle [checked]="isTrainer" (change)="trainerToggle($event)">
                {{'Is trainer profile' | GetLabelPipe}}
              </mat-slide-toggle>
            </div>
            <form [class.hidden]="!isTrainer" [formGroup]="componentForm" style="width: 100%;">
              <hr>
              <div class="fieldDescriptionLabel">{{'Trainer settings'|GetLabelPipe}}:</div>
              <div style="margin: 14px 0px; width: 100%;" class="flex-row-center flex-justify-start">
                <mat-slide-toggle [checked]="isPublished" (change)="isPublished = !isPublished" formControlName="isPublishedControl">
                  {{'Published trainer' | GetLabelPipe}}
                </mat-slide-toggle>
              </div>
              <div style="margin: 14px 0px; width: 100%;" class="flex-row-center flex-justify-start"
                   *ngFor="let trainer_type of application.account.payload_parsed['trainers_types']">
                <mat-slide-toggle formControlName="{{trainer_type + '_checkControl'}}">
                  {{trainer_type + '_trainer_type' | GetLabelPipe}}
                </mat-slide-toggle>
              </div>
              <div style="margin: 14px 0px; width: 100%;" class="flex-row-center flex-justify-start">
                <mat-form-field appearance="outline" color="accent" style="width: 100px">
                  <mat-label>sort order</mat-label>
                  <input matInput type="text" [value]="sortOrder" formControlName="sortOrderControl">
                </mat-form-field>
                <div>
                  &nbsp;&nbsp;&nbsp;{{'Trainer sort order' | GetLabelPipe}}
                </div>
              </div>
              <button mat-raised-button class="cancel widerButton font16" color="accent"
                      [matTooltip]="profilePayloadParsed['trainer_description']"
                      [disabled]="state === 'loading'"
                      (click)="changeTrainerDescription()">
                <mat-icon>subtitles</mat-icon>
                &nbsp;{{'trainer_description' | GetLabelPipe}}
              </button>
              <br><br>

              <ng-container *ngIf="application.account.calendars.length">
                <div class="fieldDescriptionLabel">{{'Inventory / Equipment restriction' | GetLabelPipe}}:</div>
                <br>
                <mat-accordion class="services-accordion" multi>
                  <mat-expansion-panel *ngFor="let calendarItem of application.account.calendars; let idx = index">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div style="margin-bottom: 12px;">{{calendarItem['NAME']}}
                          <b class="error-color" *ngIf="componentForm.get('calendar_filter_checkControl_'+calendarItem['ID']).value">ON</b>
                          <b class="success-color" *ngIf="!componentForm.get('calendar_filter_checkControl_'+calendarItem['ID']).value">OFF</b>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-slide-toggle (change)="calendarFilterToggle($event,calendarItem['ID'])"
                      formControlName="{{'calendar_filter_checkControl_'+calendarItem['ID']}}">
                      <b>{{'Enable filter' | GetLabelPipe}}</b>
                    </mat-slide-toggle>
                    <div style="margin: 14px 0px; width: 100%;" class="flex-row-center flex-justify-start"
                         *ngFor="let calendarColumn of calendarItem['parsed_params']['columns']">
                      <mat-slide-toggle formControlName="{{'calendar_column_checkControl_'+calendarItem['ID']+'_'+calendarColumn['id']}}">
                        {{calendarColumn['label']}}
                      </mat-slide-toggle>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
                <br>
              </ng-container>

              <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
                <button type="submit" class="widerButton font16" mat-raised-button color="accent"
                        (click)="handleSubmit()" [disabled]="state === 'loading'">
                  {{'save_trainer_settings'|GetLabelPipe}}
                </button>
              </div>
            </form>
          </div>
          <div style="width: 50px;"> <!-- spacer -->
          </div>
          <div class="event-description flex-column-center flex-justify-space-around" style="margin-bottom: 30px;">
            <div style="font-size: 1.0em; width: 100%;">
              <div class="fieldDescriptionLabel">{{'phone_field' | GetLabelPipe}}:</div>{{profile.shipping_phone | phoneFormatter}}<br/><br/>
              <div class="fieldDescriptionLabel">{{'fullname_field' | GetLabelPipe}}:</div> {{profile.shipping_name}} {{profile.shipping_surname}}<br/><br/>
                <div class="fieldDescriptionLabel">{{'birthday_field' | GetLabelPipe}}:</div> {{profile.birthtime ? (profile.birthtime*1000 | fsDate: true) : 'N/A' }}<br/>
            </div>
            <button mat-raised-button class="cancel widerButton font16" color="accent"
                    style="margin-top: 20px;"
                    (click)="messageUser()">
              <mat-icon>insert_comment</mat-icon>
              &nbsp;{{'message' | GetLabelPipe}}
            </button>
            <button mat-raised-button class="cancel widerButton font16" color="accent"
                    style="margin-top: 20px;"
                    (click)="showUser()">
              <mat-icon>groups</mat-icon>
              &nbsp;&nbsp;{{'open_in_connect' | GetLabelPipe}}
            </button>
          </div>
        </div>
      </div>

    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button type="button" mat-button class="cancel widerButton font16" (click)="onNoClick()">
        {{'Close'|GetLabelPipe}}
      </button>
    </div>
  </div>
</form>
